"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
// a canProceed getter could be useful for "continue" buttons but seems to be just an alias for valid 
// a firstInvalid getter could be useful for forwarding to the step the user should process next 
function findStep(stepName, steps) {
    var step = lodash_1.find(steps, (function (step) { return step.name === stepName; }));
    if (!step) {
        if (process.env.NODE_ENV !== 'development') {
            throw new Error("Step named '" + stepName + "' does not exist in Store");
        }
        return null;
    }
    return step;
}
function findStepIndex(stepName, steps) {
    var step = lodash_1.findIndex(steps, (function (step) { return step.name === stepName; }));
    if (step < 0) {
        if (process.env.NODE_ENV !== 'development') {
            throw new Error("Step named '" + stepName + "' does not exist in Store");
        }
        return null;
    }
    return step;
}
function findNextStepForStep(stepName, steps) {
    var index = findStepIndex(stepName, steps);
    if (index >= steps.length - 1)
        return null;
    return steps[index + 1];
}
function findPreviousStepForStep(stepName, steps) {
    var index = findStepIndex(stepName, steps);
    if (index === 0)
        return null;
    return steps[index - 1];
}
// get current step object
// TODO: dont depend directly on rootState, sync or refactor
function currentStep(state, _, rootState) {
    return findStep(rootState.route.name, state.steps);
}
exports.currentStep = currentStep;
// get next step for current step
function currentNext(state, getters) {
    var currentState = getters['currentStep'];
    if (!currentState)
        return null;
    return findNextStepForStep(currentState.name, state.steps);
}
exports.currentNext = currentNext;
// get prev step for current step
function currentPrev(state, getters) {
    var currentState = getters['currentStep'];
    if (!currentState)
        return null;
    return findPreviousStepForStep(currentState.name, state.steps);
}
exports.currentPrev = currentPrev;
// get is valid for current step  
function currentValid(_, getters, _rootState, rootGetters) {
    var currentState = getters['currentStep'];
    if (!currentState)
        return null;
    return rootGetters[currentState.stepConfig.validGetter];
}
exports.currentValid = currentValid;
// returns a wizard step from its name
function step(state) {
    return function (name) {
        return findStep(name, state.steps);
    };
}
exports.step = step;
// return a wizard step which is next to the one specified by name 
function next(state) {
    return function (name) {
        return findNextStepForStep(name, state.steps);
    };
}
exports.next = next;
// return a wizard step which is previous to the one specified by name 
function prev(state) {
    return function (name) {
        return findPreviousStepForStep(name, state.steps);
    };
}
exports.prev = prev;
// return a steps valid value for step specified by name
function valid(state, _, _rootState, rootGetters) {
    return function (name) {
        var step = findStep(name, state.steps);
        if (!step)
            return false;
        // cant do typesafe getters
        return rootGetters[step.stepConfig.validGetter];
    };
}
exports.valid = valid;
// returns if all wizard steps are valid
function allValid(state, getter) {
    // returns false and stays at false if one invalid step is found
    return lodash_1.reduce(state.steps, function (valid, step) {
        var validGetter = getter['valid'];
        return (valid) ? (validGetter(step.name)) : (valid);
    }, true);
}
exports.allValid = allValid;
// returns if all wizard steps are completed
function allCompleted(state) {
    // returns false and stays at false if one incompleted step is found
    return lodash_1.reduce(state.steps, function (valid, step) {
        return valid ? step.completed : valid;
    }, true);
}
exports.allCompleted = allCompleted;
// determines possibility of arbitray jumps between wizard steps
function canJumpToStep(state, getter) {
    return function (toStep, fromStep) {
        // initialize currentStep and currentStepIndex
        var currentStep;
        var currentStepIndex;
        if (fromStep) {
            currentStep = getter['step'](fromStep);
            currentStepIndex = findStepIndex(fromStep, state.steps);
        }
        else {
            try {
                currentStep = getter['currentStep'];
                currentStepIndex = findStepIndex(currentStep.name, state.steps);
            }
            catch (e) {
                // seems like we are being called from outside of the wizard. assume first step as current
                currentStep = state.steps[0];
                currentStepIndex = 0;
            }
        }
        var step = getter['step'](toStep);
        var stepIndex = findStepIndex(toStep, state.steps);
        // you can always jump to the first step, kind of implements initial behaviour
        // no matter what its valid getter says
        if (stepIndex === 0) {
            return true;
        }
        // always able to jump to a completed step 
        // (assumes that completed steps get set incompleted if their validity changes to false)
        if (step.completed) {
            return true;
        }
        // always able to jump to current.
        if (stepIndex === currentStepIndex) {
            return true;
        }
        // you can jump one step further than completed
        // -1 so we handle the first initial step
        var lastCompletedStepIndex = -1;
        state.steps.forEach(function (item, index) {
            if (item.completed) {
                lastCompletedStepIndex = index;
            }
        });
        if (lastCompletedStepIndex + 1 === stepIndex) {
            return true;
        }
        return false;
    };
}
exports.canJumpToStep = canJumpToStep;
// export everything compliant to the vuex specification for getters
exports.default = {
    currentStep: currentStep, step: step,
    currentNext: currentNext, next: next,
    currentPrev: currentPrev, prev: prev,
    currentValid: currentValid, valid: valid, allValid: allValid,
    canJumpToStep: canJumpToStep,
    allCompleted: allCompleted
};
//# sourceMappingURL=getters.js.map